import { useState } from 'react'
import { Loader2, X } from 'lucide-react'
import { iniciarConversa } from '@/services/atendimento'

export default function NovaConversaModal({
  workspaceId, canalId, onClose, onCreated,
}: {
  workspaceId: string
  canalId: string
  onClose: () => void
  onCreated: (threadId: string) => void
}) {
  const [telefone, setTelefone] = useState('')
  const [nome, setNome] = useState('')
  const [texto, setTexto] = useState('')
  const [busy, setBusy] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  const digitos = telefone.replace(/\D/g, '')
  const valido = digitos.length >= 10 && texto.trim().length > 0

  async function enviar(e: React.FormEvent) {
    e.preventDefault()
    if (!valido) return
    setBusy(true)
    setErro(null)
    const r = await iniciarConversa({ workspaceId, canalId, telefone, nome, texto })
    setBusy(false)
    if (!r.ok) { setErro(r.erro ?? 'Não foi possível iniciar a conversa'); return }
    onCreated(r.threadId!)
    onClose()
  }

  return (
    <div
      role="dialog" aria-modal="true" aria-label="Nova conversa"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15, 23, 32, .45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 16,
      }}
      onClick={onClose}
    >
      <form
        className="card"
        style={{ width: '100%', maxWidth: 380, padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}
        onClick={e => e.stopPropagation()}
        onSubmit={enviar}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <strong style={{ fontSize: 16 }}>Nova conversa</strong>
          <button
            type="button" className="btn-secondary" aria-label="Fechar"
            style={{ minHeight: 32, width: 32, padding: 0, justifyContent: 'center' }}
            onClick={onClose}
          >
            <X size={15} aria-hidden />
          </button>
        </div>

        <div>
          <div className="field-label">Telefone (WhatsApp)</div>
          <input
            className="field-input" style={{ minHeight: 40 }} autoFocus
            placeholder="(48) 98000-0010" value={telefone}
            onChange={e => setTelefone(e.target.value)} aria-label="Telefone"
          />
        </div>

        <div>
          <div className="field-label">Nome (opcional)</div>
          <input
            className="field-input" style={{ minHeight: 40 }}
            placeholder="Nome do contato" value={nome}
            onChange={e => setNome(e.target.value)} aria-label="Nome"
          />
        </div>

        <div>
          <div className="field-label">Primeira mensagem</div>
          <textarea
            className="field-input" rows={3} style={{ resize: 'vertical' }}
            placeholder="Escreva a mensagem…" value={texto}
            onChange={e => setTexto(e.target.value)} aria-label="Mensagem"
          />
        </div>

        {erro && <div className="field-error" role="alert">{erro}</div>}

        <button type="submit" className="btn-primary" style={{ minHeight: 40 }} disabled={busy || !valido}>
          {busy && <Loader2 size={15} style={{ animation: 'spin 1s linear infinite' }} aria-hidden />}
          Iniciar conversa
        </button>
        <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
      </form>
    </div>
  )
}
